<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khoảng ngày' }}
                </div>
                <div class="">
                  <CalendarRange v-model="searchParams.date" mode="date" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Tài khoản thu ngân' }}
                </div>
                <div class="">
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'name']"
                    :selected-index-field-value="searchParams.cashierId"
                    :value="searchParams.cashierId"
                    :rows="cashierRows"
                    :columns="cashierCols"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectCashier"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.code || ''} - ${
                              selectedData?.full_name || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Kế toán' }}
                </div>
                <div class="">
                  <select-with-search-table
                    style="width: 100%"
                    index-field="id"
                    :search-fields="['code', 'name']"
                    :selected-index-field-value="searchParams.accountantId"
                    :value="searchParams.accountantId"
                    :rows="accountRows"
                    :columns="accountCols"
                    :dropdown-width="400"
                    :is-remove-btn="true"
                    @selectionChanged="onSelectAccount"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      <div>
                        <span>
                          {{
                            `${selectedData?.code || ''} - ${
                              selectedData?.full_name || ''
                            }`
                          }}
                        </span>
                      </div>
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo đối chiếu doanh thu kế toán` }}
              </span>
            </div>

            <DownloadBtn
              @openNoteDialog="dialogNoteVisible = true"
              @exportExcel="downloadExcel"
            />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :pinned-bottom-row-data="pinnedBottomRowData"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Ngày giờ: Thời gian Kế toán đẩy dữ liệu lên: format: DDMMYYYY
              HHMMSS
            </li>
            <li>Thu ngân: Hiển thị tài khoản thu ngân thực hiện giao dịch</li>
            <li>
              Tổng doanh thu thực: Tổng doanh thu thu ngân đã nhận từ khách
            </li>
            <li>
              Các phương thức thanh toán: hiển thị các phương thức thanh toán
              được cấu hình và số tiền của từng phương thức thanh toán của giao
              dịch
            </li>
            <li>Tổng tiền thu: Tổng tiền Kế toán nhận được</li>
            <li>
              Các phương thức thanh toán: hiển thị các phương thức thanh toán
              được cấu hình và số tiền của từng phương thức thanh toán của giao
              dịch theo tài khoản mà kế toán nhận được
            </li>
            <li>
              Kế toán: Hiển thị họ và tên tài khoản kế toán đẩy dữ liệu lên
            </li>
            <li>
              Tổng: tiền của doanh thu thực theo từng phương thức thanh toán và
              tổng tiền của kế toán theo từng phương thức thanh toán
            </li>
            <li style="font-weight: bold">Lưu ý</li>
            <ul>
              <li>
                Với những cột là số tiền: tự động hiển thị dấu phẩy phân tách.
                Ví dụ: 100000(1 trăm) hiển thị: 100,000
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
import DownloadBtn from './components/DownloadBtn.vue'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import NoteDialog from './components/NoteDialog.vue'

import { getAccount } from '@/api/reception/common'
import {
  getCompareAccountReport,
  getCompareAccountReportExcel
} from '@/api/report_service/datntReport'

import { formatVND } from '@/utils/commonUtils'
import { downFile } from '@/utils/file-handler'

export default {
  components: { DownloadBtn, CalendarRange, NoteDialog },
  data() {
    return {
      searchParams: {
        cashierId: null,
        accountantId: null,
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null
      },
      defaultSearchParams: {
        cashierId: null,
        accountantId: null,
        date: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        },
        dateFrom: null,
        dateTo: null
      },

      // data for search
      accountRows: [],
      accountCols: [
        {
          headerName: 'Tên',
          field: 'full_name',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Code',
          field: 'code',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],
      cashierRows: [],
      cashierCols: [
        {
          headerName: 'Tên',
          field: 'full_name',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Code',
          field: 'code',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],

      // grid
      columns: [
        {
          headerName: 'Ngày giờ',
          field: 'date',
          headerClass: 'header-row-span-2',
          minWidth: 250
        },
        {
          headerName: 'Thu ngân',
          field: 'cashier',
          headerClass: 'header-row-span-2'
        },
        {
          headerName: 'Tổng doanh thu trên hệ thống',
          field: 'totalSystem',
          headerClass: 'header-row-span-2',
          cellClass: 'ag-cell-right',
          valueGetter: params => formatVND(params.data.totalSystem, null)
        },
        {
          headerName: 'Các phương thức thanh toán',
          children: [
            {
              headerName: 'Chuyển khoản',
              field: 'bankingSystem',
              cellClass: 'ag-cell-right',
              valueGetter: params => formatVND(params.data.bankingSystem, null)
            },
            {
              headerName: 'Tiền mặt',
              field: 'cashSystem',
              cellClass: 'ag-cell-right',
              valueGetter: params => formatVND(params.data.cashSystem, null)
            },
            {
              headerName: 'Thẻ',
              field: 'cardSystem',
              headerClass: 'last-header-cell-group',
              cellClass: 'ag-cell-right',
              valueGetter: params => formatVND(params.data.cardSystem, null)
            }
          ]
        },
        {
          headerName: 'Tổng tiền kế toán thu',
          field: 'totalAccountant',
          headerClass: ['header-row-span-2', 'header-cell-suffix-group'],
          cellClass: 'ag-cell-right',
          valueGetter: params => formatVND(params.data.totalAccountant, null)
        },
        {
          headerName: 'Các phương thức thanh toán',
          children: [
            {
              headerName: 'Chuyển khoản',
              field: 'bankingAccountant',
              cellClass: 'ag-cell-right',
              valueGetter: params =>
                formatVND(params.data.bankingAccountant, null)
            },
            {
              headerName: 'Tiền mặt',
              field: 'cashAccountant',
              cellClass: 'ag-cell-right',
              valueGetter: params => formatVND(params.data.cashAccountant, null)
            },
            {
              headerName: 'Thẻ',
              field: 'cardAccountant',
              headerClass: 'last-header-cell-group',
              cellClass: 'ag-cell-right',
              valueGetter: params => formatVND(params.data.cardAccountant, null)
            }
          ]
        },
        {
          headerName: 'Tổng tiền chênh lệch',
          field: 'totalDiff',
          headerClass: ['header-row-span-2', 'header-cell-suffix-group'],
          cellClass: 'ag-cell-right',
          valueGetter: params => formatVND(params.data.totalDiff, null)
        },
        {
          headerName: 'Các phương thức thanh toán',
          children: [
            {
              headerName: 'Chuyển khoản',
              field: 'bankingDiff',
              cellClass: 'ag-cell-right',
              valueGetter: params => formatVND(params.data.bankingDiff, null)
            },
            {
              headerName: 'Tiền mặt',
              field: 'cashDiff',
              cellClass: 'ag-cell-right',
              valueGetter: params => formatVND(params.data.cashDiff, null)
            },
            {
              headerName: 'Thẻ',
              field: 'cardDiff',
              headerClass: 'last-header-cell-group',
              cellClass: 'ag-cell-right',
              valueGetter: params => formatVND(params.data.cardDiff, null)
            }
          ]
        },
        {
          headerName: 'Kế toán',
          field: 'accountant',
          headerClass: ['header-row-span-2', 'header-cell-suffix-group']
        }
      ],
      rows: [],
      pinnedBottomRowData: [],

      // dialog
      dialogNoteVisible: false
    }
  },
  async mounted() {
    await this.getListAccountant()
    await this.getListCashier()
    await this.fnGetCompareAccountReport()
  },
  methods: {
    onSearch() {
      this.fnGetCompareAccountReport()
    },
    onResetSearch() {
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetCompareAccountReport()
    },

    onSelectCashier(selected) {
      this.searchParams.cashierId = selected?.id
    },
    onSelectAccount(selected) {
      this.searchParams.accountantId = selected?.id
    },

    // handle api call
    async getListAccountant() {
      const res = await getAccount({ department: 'ACC' })
      this.accountRows = res.data.map(item => {
        return {
          id: item.account.id,
          code: item.account.code,
          full_name: item.account.full_name
        }
      })
    },
    async getListCashier() {
      const res = await getAccount({ department: 'CASHIER' })
      this.cashierRows = res.data.map(item => {
        return {
          id: item.account.id,
          code: item.account.code,
          full_name: item.account.full_name
        }
      })
    },

    async fnGetCompareAccountReport() {
      try {
        const query = {
          cashierId: this.searchParams.cashierId,
          accountantId: this.searchParams.accountantId,
          dateFrom: this.searchParams.date.start,
          dateTo: this.searchParams.date.end
        }
        const res = await getCompareAccountReport(query)
        this.rows = res.data
        this.pinnedBottomRowData = [
          {
            ...this.rows.pop(),
            date: 'Tổng',
            accountant: ''
          }
        ]
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    },
    async downloadExcel() {
      try {
        const query = {
          cashierId: this.searchParams.cashierId,
          accountantId: this.searchParams.accountantId,
          dateFrom: this.searchParams.date.start,
          dateTo: this.searchParams.date.end
        }
        const res = await getCompareAccountReportExcel(query)
        const date = this.$moment().format('DD-MM-YYYY')
        downFile(res, 'bao_cao_doi_chieu_doanh_thu_ke_toan_' + date + '.xlsx')
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    }
  }
}
</script>
